import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Components
import SideNav from '@components/individualPortal/navigation/SideNavigation';


// ActionCreators
import { showModal } from '@actions/common/actionCreators';
import { verifyAccessCode } from '@actions/individualPortal/dashboard/dashboardActionCreators';
import { getTickets } from '@actions/individualPortal/ticket/ticketActionCreators';
import { fetchUnreadNotificationCount } from '@actions/individualPortal/secureInbox/secureInboxActionCreators';

// Constants
import { ssapModalTypes } from '@constants/ssap/modals/ssapModalTypes';
import { configs } from '@constants/configs/configs';
import { navLinks } from './configs/dashboardSideNavConfigs';

const SideNavContainer = props => {
    const {
        actions: {
            showModal,
            verifyAccessCode
        },
        environment: {
            stateCode,
            links,
            links: {
                CALHEERS_URL,
                MANAGE_ASSISTER
            },
            user,
            designationHistoryEnabled,
            preventConsumerPreferencePageAccess,
            telexEnabled,
            ticketEnabled,
            flags: {
                multiHouseholdEnabled
            },
            communicationPrefReviewCount,
        }
    } = props;

    const { role, householdCaseId } = user || {};
    const replacements = { CALHEERS_URL, MANAGE_ASSISTER, householdCaseId };
    const [ accessCode, setAccessCode ] = useState('');
    const [ btnState, setBtnState ] = useState(true);

    const handleOpeningModal = () => {
        showModal({
            modalType: ssapModalTypes.LOCATE_ASSISTANCE_MODAL
        });
    };

    const changeAccessCodeHandle = (e) => {
        e.preventDefault();
        setAccessCode(e.target.value);
        setBtnState(e.target.value === '');
    };
    const submitAccessCodeHandle = () => {
        verifyAccessCode(configs.endpoints.VERIFY_ACCESS_CODE.processReplacements({ accessCode }), {});
    };
    return (
        <SideNav
            {...{ stateCode, replacements, links }}
            code={accessCode}
            navLinks={navLinks}
            userRole={role}
            onChange={changeAccessCodeHandle}
            onClick={handleOpeningModal}
            onSubmit={submitAccessCodeHandle}
            visibilityParams={{ designationHistoryEnabled, multiHouseholdEnabled, telexEnabled, ticketEnabled, preventConsumerPreferencePageAccess }}
            telexEnabled={telexEnabled}
            isDisabled={btnState}
            communicationPrefReviewCount={communicationPrefReviewCount}
        />
    );
};
const mapStateToProps = state => ({
    environment: state.common.environment
});
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        verifyAccessCode,
        showModal,
        getTickets,
        fetchUnreadNotificationCount
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(SideNavContainer);